export const isNullish = <T>(
  target: T | null | undefined,
): target is null | undefined => {
  return target === null || target === undefined
}

export default isNullish
